
    // @ts-nocheck
    import { __internal_buildRpcClient } from "@blitzjs/rpc";
    export default __internal_buildRpcClient({
      resolverName: "getSchoolConfig",
      resolverType: "query",
      routePath: "/getSchoolConfig",
      httpMethod: "POST",
    });
  